import { render } from "./AgingPatientTable.vue?vue&type=template&id=31bacb03"
import script from "./AgingPatientTable.vue?vue&type=script&lang=js"
export * from "./AgingPatientTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__